import React, { FC } from 'react';
import LottieControl from '@components/LottieControl';

const Checkmark: FC = () => (
  <LottieControl src="/animations/4964-check-mark-success-animation.json" />
);

export default Checkmark;
